











































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { TypePartenaireFASTT } from "@/api/models/FASTT/typesPartenaire/typesPartenaire";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BFormCheckbox,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import CreateTypePartenaire from "./Create.vue";
import UpdateTypePartenaire from "./EditType.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BAlert,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateTypePartenaire,
    UpdateTypePartenaire
  }
})
export default class ListTypesPartenairesFASTT extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isSortDirDesc = false;
  sortBy = "libelle";
  selectedTypePartenaireId = "";

  isAddNewTypePartenaireSidebarActive = false;
  isUpdateTypeSidebarActive = false; 

  tableColumns = [
    { key: "libelle", sortable: true },
    { key: "detailsLevel", label: "Niveau de détails", sortable: true },
    { key: "actions", sortable: false },
  ];
  paginatedListTypesPartenairesFASTT = new PaginatedList<TypePartenaireFASTT>();

  async created() {
    await this.loadListTypesPartenairesFASTT({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListTypesPartenairesFASTT.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListTypesPartenairesFASTT.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  @Watch("pertinentOnly")
  async paginationChanged() {
    await this.loadListTypesPartenairesFASTT({
      pageNumber: this.currentPage,
      pageSize: this.perPage,

      
      search: this.searchQuery
    });
  }

  @Watch('searchQuery')
  @Watch("sortBy")
  @Watch("isSortDirDesc")
  async searchTypesPartenaire() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListTypesPartenairesFASTT({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc,
        search: this.searchQuery
      })
    }, 1200);
  }

  editTypePartenaire(typePartenaireId: string) {
    this.selectedTypePartenaireId = typePartenaireId;
    this.isUpdateTypeSidebarActive = true;
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;

    this.loadListTypesPartenairesFASTT(params);
  }

  async loadListTypesPartenairesFASTT(params: any) {
    if (!params || params?.reset) {
      this.paginatedListTypesPartenairesFASTT = new PaginatedList<TypePartenaireFASTT>();
    }
    await this.$http.myressif.typesPartenaireFASTT
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? "",
        params?.pertinentOnly,
      )
      .then((response: PaginatedList<TypePartenaireFASTT>) => {
        this.paginatedListTypesPartenairesFASTT = response;
      });
  }

  
  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce type de partenaire ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.typesPartenaireFASTT
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un type de partenaire",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loadListTypesPartenairesFASTT({
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }


  onRowSelected(record: any) {
    this.$router.push({
      name: "details-types-partenaires-fastt",
      params: { id: record.id },
    });
  }
}
